import {useNavigate} from "react-router-dom";
import {useState} from "react";
import {handleError} from "../utils2";

export function useFetchJson(jwtToken = null, defaultValue = null, method = "POST") {
    const navigate = useNavigate()
    const [value, setValue] = useState(defaultValue)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    function exec(url, payload, cb = null) {
        if (url == null) {
            return setError("URL unprovided")
        }

        const bearer = jwtToken ? {Authorization: `Bearer ${jwtToken}`} : null

        const requestOptions = {
            method: method,
            headers: {"Accept": "application/json", "Content-Type": "application/json", ...bearer},
            body: method === 'GET' || payload == null ? null : JSON.stringify(payload)
        }

        setLoading(true)
        fetch(url, requestOptions)
            .then(resp => resp?.ok ? resp.text() : Promise.reject({error: `Response status: ${resp.status}`}))
            .then(text => JSON.parse(text))
            .then(json => {
                if (json?.ok || json?.success) {
                    setValue(json.data)
                    if (typeof cb === "function") {
                        cb(json)
                    } else if (typeof cb === "string") {
                        navigate(cb)
                    }
                    console.debug("Got: ", json?.body)
                } else {
                    console.warn("Got: ", JSON.stringify(json))
                    return Promise.reject(json)
                }
            })
            .catch(handleError)
            .catch(err => {
                console.warn(err)
                return Promise.reject(err)
            })
            .catch(setError)
            .finally(() => setLoading(false))
    }

    const clearError = () => setError(null)

    const setData = param => {
        if (typeof param === "function") {
            setValue(prev => ({...prev, data: param(prev.data)}))
        } else {
            setValue(prev => ({...prev, data: param}))
        }
    }

    return {exec, data: value?.data, setData, loading, setLoading, error, clearError}
}